import React from 'react';
import Header from './Header';
import Footer from './Footer';
import '../styles/Solutions.css';
import { FaArrowRight } from 'react-icons/fa';
import energyImg from '../assets/solution-energy.jpg';
import semiImg from '../assets/solution-semiconductor.jpg';
import robotImg from '../assets/solution-robot.jpg';
import electronicsImg from '../assets/solution-electronics.jpg';
import logisticsImg from '../assets/solution-logistics.jpg';
import medicalImg from '../assets/solution-medical.jpg';
import packagingImg from '../assets/solution-packaging.jpg';
import automotiveImg from '../assets/solution-automotive.jpg';
import batteryImg from '../assets/solution-batteryImg.png';
import foodImg from '../assets/FoodAndBeveragesMain.jpeg';
import portImg from '../assets/PortMain.jpeg';
import printImg from '../assets/solution-printImg.jpg';
import rubberImg from '../assets/solution-rubberImg.jpg';

const industryData = [
  {
    title: 'Energy Industry',
    desc: 'From electrode manufacturing and battery cell assembly to cell finishing to module and pack assembly, we provide sensors that address your specific needs in cycle time, traceability, and quality control.',
    image: energyImg,
    link: '/solutions/EnergyIndustry',
  },
  {
    title: 'Semiconductor Industry',
    desc: 'We already serve customers from the semiconductor manufacturing segment in various areas such as wafer handling, wafer processing or carrier handling.',
    image: semiImg,
    link: '/solutions/semiconductor',
  },
  {
    title: 'Industrial Robots',
    desc: 'Whether condition monitoring or collaboration between humans and robots, machines and actuators, we offer you a comprehensive portfolio of sensor technology.',
    image: robotImg,
    link: '/solutions/IndustrialRobots',
  },
  {
    title: 'Electronics Industry',
    desc: 'Our products help you meet the requirements from intralogistics and traceability, robotics, handling and assembly technology to machine vision and condition monitoring.',
    image: electronicsImg,
    link: '/solutions/ElectronicsIndustry',
  },
  {
    title: 'Logistics Industry',
    desc: 'Logistics combined with a suitable sensor technology is a significant factor in meeting the growing requirements on an efficient supply chain in regard to throughput, availability, flexibility and safety.',
    image: logisticsImg,
    link: '/solutions/LogisticsIndustry',
  },
  {
    title: 'Medical Technology',
    desc: 'We offer you a full-range of products and system solutions tailored to individual tasks for laboratory automation, medical technology and hospital logistics.',
    image: medicalImg,
    link: '/solutions/MedicalTechnology',
  },
  {
    title: 'Packaging Industry',
    desc: 'Our solutions address key pain points – from achieving precise quality control and optimizing high-speed production lines to ensuring flawless condition monitoring.',
    image: packagingImg,
    link: '/solutions/packaging',
  },
  {
    title: 'Automotive Industry',
    desc: 'From initial stamping to welding, painting, forging and casting to final assembly, we know every area down to the finest details and offer just the right sensors.',
    image: automotiveImg,
    link: '/solutions/automobiles',
  },
  // {
  //   title: 'Battery Industry',
  //   desc: 'Whether cell manufacturing, module and pack assembly or final inspection, we provide specialized sensors and solutions tailored to every step of battery production.',
  //   image: batteryImg,
  //   link: '/solutions/battery',
  // },
  {
    title: 'Food And Beverages',
    desc: 'From hygienic packaging to precise filling and labeling, our smart sensor solutions ensure safety, efficiency, and compliance in food and beverage processes.',
    image: foodImg,
    link: '/solutions/foodanddrink',
  },
  {
    title: 'Port',
    desc: 'In port automation and logistics, our rugged sensors support container detection, crane positioning, and safety systems in challenging outdoor environments.',
    image: portImg,
    link: '/solutions/port',
  },
  // {
  //   title: 'Printing',
  //   desc: 'We enable precise print mark detection, web guiding, and registration control with high-performance sensors designed for dynamic print and packaging lines.',
  //   image: printImg,
  //   link: '/solutions/print',
  // },
  {
    title: 'Rubber and Plastic Industry',
    desc: 'From extrusion monitoring to mold detection and handling automation, our sensors deliver reliable performance in high-temperature and complex rubber and plastic environments.',
    image: rubberImg,
    link: '/solutions/RubberAndPlastic',
  }
];

const Solutions = () => {
  return (
    <div className="solutions">
      <Header />

      {/* Hero Banner Section */}
      {/* <section className="hero-banner6">
        <div className="hero-content">
          <h1>Solution</h1>
          <div className="breadcrumb">
            <span><a href="/" style={{ color: "#ACECFC" }}>Home</a></span> ⪢ <span>Solution</span>
          </div>
        </div>
      </section> */}

      {/* Intro Text */}
      <section className="intro-section">
        <h2 className="intro-title">Solutions</h2>
        <p>
          We are experts in industrial sensors, dedicated to helping make your equipment perform more competitively in today’s market.
        </p>
      </section>


      {/* Industry Grid Section */}
      <section className="industry-grid">
        {industryData.map((item, index) => (
      <div className="industry-card" key={index}>
        <a href={item.link}>
          <img src={item.image} alt={item.title} />
          <h3>{item.title}</h3>
          <p>{item.desc}</p>
        </a>
      </div>
        ))}
      </section>

{/* Contact Form Section */}
<section className="quote-contact-box">
        <div className="quote-form-container">
          <div className="quote-left">
            <h2>Please leave a message to get a quotation and tailored solution</h2>
          </div>
          <div className="quote-form">
            <form onSubmit={(e) => {
              e.preventDefault();

              // Get form field values
              const name = e.target.elements[0].value;
              const phone = e.target.elements[1].value;
              const email = e.target.elements[2].value;
              const company = e.target.elements[3].value;
              const message = e.target.elements[4].value;

              // Construct the email subject
              const subject = encodeURIComponent("Quotation & Solution Request from Website");

              // Construct the email body with the added "Request for Quote:" line
              const body = encodeURIComponent(
                `Request for Quote:\n\n` + // ++ Added this line
                `Name: ${name}\n` +
                `Phone: ${phone}\n` +
                `Email: ${email}\n` +
                `Company: ${company}\n` +
                `Message:${message}`
              );

              // Define the recipient email address
              const recipientEmail = "sales@fu-tekautomation.co.in"; // **IMPORTANT: Replace with your actual email address**

              // Construct the mailto URL
              const mailtoURL = `mailto:${recipientEmail}?subject=${subject}&body=${body}`;

              // Open the default email client
              window.location.href = mailtoURL;
            }}>
              <input type="text" placeholder="Contact (Full Name)" required />
              <input type="tel" placeholder="Phone" required />
              <input type="email" placeholder="Email address" required />
              <input type="text" placeholder="Company name" required />
              <textarea placeholder="Message" required></textarea>
              <button type="submit">Send <FaArrowRight /></button>
            </form>
          </div>
        </div>
      </section>


      <Footer />
    </div>
  );
};

export default Solutions;
